import reduceReducers from 'reduce-reducers'
import { languageMapping, makeApiTypes } from 'sidecar-utility-library'

import { default as BasicReducer } from './Basic'
import { default as CareReducer } from './Care'
import { default as DoctorReducer } from './Doctor'
import { default as ExpenseReducer } from './Expense'
import { default as LocationReducer } from './Location'
import { default as TransactionReducer } from './Transactions'

export * from './Basic'
export * from './Care'
export * from './Doctor'
export * from './Expense'
export * from './Location'
export * from './Transactions'

export const types = {
  UPDATE_SEARCH_FILTERS: 'searchFilters/UPDATE_SEARCH_FILTERS',
  RESET_SEARCH_FILTERS: 'searchFilters/RESET_SEARCH_FILTERS',
  DELETE_SEARCH_FILTER: 'searchFilters/DELETE_SEARCH_FILTER',
  RESET_SEARCH_OPTIONS: 'searchFilters/RESET_SEARCH_OPTIONS',
  SET_SEARCH_TO_MAP_LOC: 'searchFilters/SET_SEARCH_TO_MAP_LOC',
  GET_DOCTOR_SORT_BY_OPTIONS: 'searchFilters/GET_DOCTOR_SORT_BY_OPTIONS',
  ...makeApiTypes('FETCH_EXPENSE_FILTER_OPTIONS', 'searchFilters'),
  ...makeApiTypes('FETCH_TRANSACTION_FILTER_OPTIONS', 'searchFilters'),
}

export const initialState = {
  // the search filters can be pretty much anything
  // so we don't really have a structure here. It's
  // up to whatever is using the search filters to
  // determine how they are organized in here. It's
  // essentially going to be key:value pairs anyway.
  filters: {},

  // the filterOptions can also be anything, but in
  // general, this should be the only place where
  // search components get the data to generate
  // whatever UI is required to select the options.
  // Gender, ages and languages are not supplied by an API.
  // careTypes can be supplied by an API but since we're not
  // using nested filters, we can just set the initial state
  // with these values so we don't have to wait on the API to resolve
  filterOptions: {
    priceFairnessOptions: [
      { label: 'Any', value: '' },
      { label: '$', value: 'Low' },
      { label: '$$', value: 'Fair' },
      { label: '$$$', value: 'High' },
    ],
    providerTypes: [
      { label: 'Any', value: '' },
      { label: 'Individual', value: 'Individual' },
      { label: 'Organization', value: 'Organization' },
    ],
    genders: [
      { label: 'Any', value: '' },
      { label: 'Male', value: 'MALE' },
      { label: 'Female', value: 'FEMALE' },
    ],
    ageGroups: [
      { label: 'Any', value: '' },
      { label: '0-17', value: 'YOUNG' },
      { label: '18-65', value: 'ADULT' },
      { label: '65+', value: 'SENIOR' },
    ],
    languages: [{ name: 'Any', label: 'Any', value: '' }, ...languageMapping],
    careTypes: [
      {
        value: 'prescriptions',
        label: 'Prescriptions',
      },
      {
        value: 'therapy-rehab',
        label: 'Therapy/rehab',
      },
      {
        value: 'hospital-admission',
        label: 'Hospital admission',
      },
      {
        value: 'doctor-visit',
        label: 'Doctor visit',
      },
      {
        value: 'medicine',
        label: 'Medicine',
      },
      {
        value: 'surgery',
        label: 'Surgery',
      },
      {
        value: 'equipment-supplies',
        label: 'Equipment/supplies',
      },
      {
        value: 'x-rays-imaging-radiology',
        label: 'X-rays, imaging, radiology',
      },
      {
        value: 'lab-work',
        label: 'Lab work',
      },
      {
        value: 'transportation',
        label: 'Transportation',
      },
      {
        value: 'maternity-care',
        label: 'Maternity care',
      },
      {
        value: 'same-day-facility-services',
        label: 'Same-day facility services',
      },
    ],
  },

  // these are the 'active' filters in that they are the ones
  // that are actively being applied in the search results being
  // displayed to the user. Whenever the searchFilters are used in
  // a request that is successful, those filters will be considered
  // 'active' and be copied to the activeFilters property here.
  // This is generally used by filter components that merely
  // display the filters that are currently being used, but should
  // not display the filters as they are updated in real-time.
  // For example, as user types the searchQuery, filter tags
  // should not update as the user types.
  activeFilters: {},
}

export default reduceReducers(
  BasicReducer,
  CareReducer,
  DoctorReducer,
  ExpenseReducer,
  LocationReducer,
  TransactionReducer,
  // the last arg MUST be initialState
  initialState,
)
